import React from 'react';
import API_CONFIG from '../../config/api';

// Small disc: profile photo if there is one, otherwise the first letter of the
// email on an elevated hairline circle. Monochrome — no gold.
const Avatar = ({ user, size = 30, className = '' }) => {
  const src = user?.profile_picture
    ? `${API_CONFIG.UPLOADS_BASE_URL}/profile_pictures/${user.profile_picture}`
    : null;
  return (
    <span
      className={`inline-grid place-items-center shrink-0 rounded-full bg-elev border border-line-strong text-fg font-[600] text-xs overflow-hidden ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {src ? (
        <img src={src} alt="" className="w-full h-full object-cover" />
      ) : (
        user?.email?.charAt(0).toUpperCase() || '·'
      )}
    </span>
  );
};

export default Avatar;
